import { GraduationCap } from "lucide-react";
import { motion } from "framer-motion";

import { Button } from "@core/button";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export function MadlenAkademiButton({
  handleAkademiConfirm,
  akademiLoading,
  highlight = false,
}: {
  handleAkademiConfirm: () => void;
  akademiLoading: boolean;
  highlight?: boolean;
}) {
  const { t } = useTranslation();

  const glowVariants = {
    highlighted: {
      scale: 1.02,
      background: [
        "linear-gradient(to right, hsl(210, 70%, 55%), hsl(220, 70%, 60%))",
        "linear-gradient(to right, hsl(180, 65%, 50%), hsl(210, 65%, 55%))",
        "linear-gradient(to right, hsl(120, 60%, 50%), hsl(180, 60%, 50%))",
        "linear-gradient(to right, hsl(60, 65%, 55%), hsl(120, 65%, 50%))",
        "linear-gradient(to right, hsl(30, 70%, 55%), hsl(60, 70%, 55%))",
        "linear-gradient(to right, hsl(0, 70%, 60%), hsl(30, 70%, 55%))",
        "linear-gradient(to right, hsl(300, 65%, 60%), hsl(0, 65%, 60%))",
        "linear-gradient(to right, hsl(240, 70%, 60%), hsl(300, 70%, 60%))",
        "linear-gradient(to right, hsl(210, 70%, 55%), hsl(220, 70%, 60%))",
      ],
    },
    normal: {
      scale: 1,
      background: "linear-gradient(to right, #3B82F6, #2563EB)",
    },
  };

  return (
    <motion.div
      variants={glowVariants}
      animate={highlight ? "highlighted" : "normal"}
      transition={
        highlight
          ? {
              duration: 3,
              repeat: Infinity,
              ease: "linear",
            }
          : { duration: 0.3 }
      }
      className={`rounded-xl ${highlight ? "z-10" : ""}`}
    >
      <Button
        onClick={() => {
          handleAkademiConfirm();
        }}
        disabled={akademiLoading}
        style={{
          background: highlight ? undefined : glowVariants.normal.background,
        }}
        className={`flex w-full items-center justify-between p-3 rounded-xl transform group-hover:scale-[1.02] transition-transform duration-200 shadow-md group-hover:shadow-lg group whitespace-nowrap ${akademiLoading ? "opacity-50 cursor-not-allowed pointer-events-none" : ""} ${highlight ? "" : "hover:scale-[1.02]"}`}
      >
        <div className="flex items-center space-x-3">
          <GraduationCap size={24} className="text-white" />
          <div className="flex flex-col items-start">
            <span className="text-sm font-semibold text-white">
              {t("madlenAkademi.title")}
            </span>
            <span className="text-xs text-blue-100">
              {t("madlenAkademi.description")}
            </span>
          </div>
        </div>
        <ArrowRight
          size={20}
          className="text-white transform group-hover:translate-x-1 transition-transform duration-200"
        />
      </Button>
    </motion.div>
  );
}
